import { Center, Grid, GridItem, Image } from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

import { GridImage } from './components/GridImage';
import { GridImagePlusMore } from './components/GridImagePlusMore';

export const ImageGrid: React.FC<{
  urls?: (string | null)[];
  onClickImage: (index: number) => Promise<void>;
}> = ({ urls, onClickImage }) => {
  if (!urls || urls.length === 0) {
    return null;
  } else if (urls.length === 1) {
    return (
      <Center width="full">
        <Image
          onClick={() => onClickImage(0)}
          src={urls[0] || undefined}
          _hover={{ cursor: 'pointer' }}
          maxH={'580px'}
          fallback={<ImageFallback w="full" h="370px" />}
          alt=""
        />
      </Center>
    );
  } else if (urls.length === 2) {
    return (
      <Grid
        templateColumns="repeat(2, minmax(0, 1fr))"
        gap={'2px'}
        h="580px"
        w="full"
      >
        {urls.map((src, index) => (
          <GridItem
            key={`postEmbeddedImage:${index}`}
            onClick={() => onClickImage(index)}
            overflow="hidden"
            w="full"
          >
            <GridImage src={src || undefined} />
          </GridItem>
        ))}
      </Grid>
    );
  } else if (urls.length === 3) {
    return (
      <Grid
        templateColumns="repeat(2, minmax(0, 1fr))"
        templateRows="repeat(2, minmax(0, 1fr))"
        gap={'2px'}
        h="580px"
        w="full"
      >
        {urls.map((src, index) => (
          <GridItem
            key={`postEmbeddedImage:${index}`}
            rowSpan={index === 0 ? 2 : 1}
            onClick={() => onClickImage(index)}
            overflow="hidden"
            w="full"
          >
            <GridImage src={src || undefined} />
          </GridItem>
        ))}
      </Grid>
    );
  } else {
    return (
      <Grid
        templateColumns="minmax(0, 2fr) minmax(0, 1fr)"
        templateRows="repeat(3, minmax(0, 1fr))"
        gap={'2px'}
        h="580px"
        w="full"
      >
        {urls.slice(0, 4).map((src, index) => (
          <GridItem
            key={`postEmbeddedImage:${index}`}
            rowSpan={index === 0 ? 3 : 1}
            onClick={() => onClickImage(index)}
            overflow="hidden"
            w="full"
          >
            {index === 3 && urls.length > 4 ? (
              <GridImagePlusMore src={src} numOtherImages={urls.length - 4} />
            ) : (
              <GridImage src={src || undefined} />
            )}
          </GridItem>
        ))}
      </Grid>
    );
  }
};
